import axiosInstance from "core/api/axiosInstance";

export function validateSwitchOperation(payload) {
  let value = payload;
  for (
    let depth = 0;
    depth < 6 && value && typeof value === "object" && !Array.isArray(value);
    depth++
  ) {
    if (
      value.success === false ||
      value.error ||
      (value.code != null && Number(value.code) !== 0) ||
      Number(value.status) >= 400
    )
      throw new Error(
        value.message || value.msm || value.error || "El backend no aceptó la operación"
      );
    value = value.data;
  }
  return payload;
}

// Obtener todos los switches
export const getSwitchesService = async () => {
  try {
    const { data } = await axiosInstance.get("/api/automatization/get");
    return data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error al obtener switches");
  }
};

// Obtener opciones de software para el select
export const getSoftwareOptionsService = async () => {
  try {
    const { data } = await axiosInstance.get("/api/automatization/get-sw");
    return data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error al obtener opciones de software");
  }
};

// Crear nuevo switch
export const createSwitchService = async (switchData) => {
  try {
    const { data } = await axiosInstance.post("/api/automatization/create-switch", switchData);
    return data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error al crear el switch");
  }
};

// Actualizar switch existente
export const updateSwitchService = async (switchData) => {
  try {
    const { data } = await axiosInstance.put("/api/automatization/update-switch", switchData);
    return data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error al actualizar el switch");
  }
};

// Reiniciar un switch específico por ID
export const resetSwitchByIdService = async (idswitchport) => {
  try {
    const { data } = await axiosInstance.post(`/api/automatization/set-reset/${idswitchport}`, {});
    return validateSwitchOperation(data);
  } catch (error) {
    throw new Error(
      error.response?.data?.message || error.message || "Error al reiniciar el switch"
    );
  }
};

// Reiniciar TODOS los switches
export const resetAllSwitchesService = async () => {
  try {
    const { data } = await axiosInstance.post(
      "/api/automatization/set-reset-all",
      {},
      { timeout: 840000 } // 14 minutos timeout
    );
    return validateSwitchOperation(data);
  } catch (error) {
    throw new Error(
      error.response?.data?.message || error.message || "Error al reiniciar todos los switches"
    );
  }
};

// Cambiar estado de un switch
export const changeSwitchStatusService = async (idswitchport) => {
  try {
    const { data } = await axiosInstance.post(
      `/api/automatization/change-status/${idswitchport}`,
      {}
    );
    return validateSwitchOperation(data);
  } catch (error) {
    throw new Error(
      error.response?.data?.message || error.message || "Error al cambiar el estado del switch"
    );
  }
};

// Obtener informe de switches
export const getSwitchesInform = async () => {
  try {
    const { data } = await axiosInstance.get("/api/automatization/get-report-switch");
    return data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Error al obtener informe");
  }
};

// Opcional: Función con manejo de errores más detallado
export const getSwitchesServiceDetailed = async () => {
  try {
    const { data } = await axiosInstance.get("/api/automatization/get", {
      timeout: 30000, // 30 segundos timeout
    });
    return data;
  } catch (error) {
    console.error("Error en getSwitchesService:", error);

    if (error.code === "ECONNABORTED") {
      throw new Error("⏱️ Tiempo de espera agotado. Verifique la conexión.");
    }
    if (error.code === "ERR_NETWORK") {
      throw new Error("🌐 Error de conexión. Verifique su internet.");
    }
    if (error.response?.status === 401) {
      throw new Error("🔒 Sesión expirada. Por favor, inicie sesión nuevamente.");
    }

    throw new Error(error.response?.data?.message || "Error al obtener switches");
  }
};
